import {
  discoveryApiRef,
  oauthRequestApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import { autheliaAuthApiRef } from '@internal/plugin-waadoo-core';
import { refreshLatch } from './refreshLatch';
import { WaadooAuthConnector } from './waadooAuthConnector';

/**
 * Upstream's OAuth2 API on our own connector, which stops refreshing after a
 * failed refresh until the user signs in again — see `waadooAuthConnector.ts`.
 * Same provider, environment, redirect flow and scopes as `OAuth2.create`
 * with its default connector.
 */
export const autheliaAuthApi = ApiBlueprint.make({
  name: 'authelia-auth',
  params: defineParams =>
    defineParams({
      api: autheliaAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          authConnector: new WaadooAuthConnector({
            discoveryApi,
            oauthRequestApi,
            provider: {
              id: 'oidc',
              title: 'Authelia OIDC',
              icon: () => null,
            },
            // OAuth2's default when unset.
            environment:
              configApi.getOptionalString('auth.environment') ?? 'development',
            redirectFlow:
              configApi.getOptionalBoolean('enableExperimentalRedirectFlow') ??
              false,
            latch: refreshLatch,
          }),
          defaultScopes: ['openid', 'profile', 'email', 'groups'],
        }),
    }),
});
